import {basePortalApi as api} from "../basePortalApi";
import {toastError} from "../../common/utils/toastMessages";
import {t} from "i18next";
import {
  PortalExecuteWorkflowCommandValuesDto,
  WorkflowExecutionResultDto,
} from "../workflowTriggers/workflowExecution-api";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCommodityTypes: build.query<
      CommodityTypeGetCommodityTypesApiResponse,
      CommodityTypesGetApiArg
    >({
      query: (arg) => {
        const organizationId = process.env
          .REACT_APP_PORTAL_ORGANIZATION_ID as unknown as number;
        return {
          url: `/api/organizations/${organizationId}/workflowTriggers/${arg.workflowId}`,
          method: "POST",
          body: arg.values,
        };
      },
      async onQueryStarted(args, {queryFulfilled}) {
        try {
          await queryFulfilled;
        } catch (error) {
          toastError(t("toasts.serverError"));
        }
      },
    }),
  }),
  overrideExisting: false,
});
export {injectedRtkApi as portalApi};
export type CommodityTypeGetCommodityTypesApiResponse =
  /** status 200  */ WorkflowExecutionResultDto;

export type CommodityTypesGetApiArg = {
  workflowId: string;
  values: PortalExecuteWorkflowCommandValuesDto;
};
export type CommodityTypesGetValues = {
  search: string;
};
export type LinkDto = {
  href?: string | null;
  rel?: string | null;
  type?: string | null;
  templated?: boolean | null;
};
export type CommodityTypeDto = {
  commodityTypeId?: number;
  code?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;
  lastModified?: Date;
  lastModifiedBy?: string | undefined;
  organizationId?: number;
  links?: LinkDto[] | undefined;
  customValues?: {
    [key: string]: string;
  } | null;
};
export type CommodityTypeDtoPagedResult = {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: CommodityTypeDto[] | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  extensions?: {
    [key: string]: any;
  };
  [key: string]: any | null;
};
export type GetCommodityTypesValues = {
  limit?: number | null;
  offset?: number | null;
  sort?: string;
  filter?: string;
  search?: string;
};
export const {useGetCommodityTypesQuery} = injectedRtkApi;
